import React, { useCallback, useEffect, useState, useRef } from "react";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeaderBoardWithCoin from "../components/LeaderBoardWithCoin";
import { useNavigate, useParams } from "react-router-dom";
import ModalComponent from "../components/Modal";
import LoadingScreen from "./LoadingScreen";
import { GoBell } from "react-icons/go";
import NotificationModal from "../components/NotificationModal";
import FooterNavbar from "../components/FooterNavbar";
import { messaging } from "../utils/Firebase";
import { getToken } from "firebase/messaging";
import { MONTHLY_COINS } from "../constants/coins";

const styles = require("../styles/myfile.module.css").default;
const logoImage = require("../assets/images/Group 26943.png");
const becomeCoins = require("../assets/images/big-coin.png");

interface coinsInfo {
  index: number;
  size: number;
}

const Coins = ({ index, size }: coinsInfo) => {
  const styleforcoin = size - index;
  return (
    <>
      <div className={styles.coin} style={{ zIndex: styleforcoin }}>
        <img src={becomeCoins} alt="" />
      </div>
    </>
  );
};

const Home = () => {
  const [userDetails, setUserDetails] = useState<any>();
  const [isLoading, setIsLoading] = useState<any>(true);
  const [transactionCount, setTransactionCount] = useState(0);
  const [unseenTransactions, setUnseenTransactions] = useState([]);
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [img, setImg] = useState<any>();
  const [imageAvailable, setImageAvailable] = useState(false);

  let { userId } = useParams();

  const navigator = useNavigate();

  const hasRequestedPermission = useRef(false);

  useEffect(() => {
    const requestPermission = async () => {
      if (hasRequestedPermission.current) return;
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: "BEcWci33tQVvG8HTivfYVOrx2wLQQawhgbvOYGTJE0_ZD8ykqu26o34hySSeY-HfU08DgpI-F_aRDssZV_iE20g",
        });
        console.log("Notification permission granted.", token);
        hasRequestedPermission.current = true;
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/save-token`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              body: JSON.stringify({ token, userId }),
            }
          );
          if (!response.ok) {
            throw new Error("Failed to save token");
          }
          console.log("Token saved successfully.");
        } catch (error) {
          console.error("Error saving token:", error);
        }
      } else if (permission === "denied") {
        console.log("Notification permission denied.");
        alert("Please allow notification");
      } else {
        alert("Please allow notification");
        console.log("Notification permission denied.");
      }
    };
    requestPermission();
  }, [userId]);

  const handleCelebrateClick = () => {
    if (userDetails.current_coins <= 0) {
      toast.warn("you don't have enough coins", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }
    navigator("/profile");
  };

  const handleProflileClick = (e: any) => {
    e.preventDefault();
    navigator(`/my-page/${userDetails.user_id}`);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenModal = () => {
    handleNotificationClick().then(() => {
      setShowModal(true);
      setTransactionCount(0);
    });
  };
  const handleCloseModal = () => setShowModal(false);

  const resetDate = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/reset-coins`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log("Error while resetting the date");
      console.error(err);
    }
  }, []);

  const fetchUserDetails = useCallback(async () => {
    try {
      const response: any = await fetch(
        `${process.env.REACT_APP_API_URL}/profile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({
            userId: userId,
          }),
        }
      );
      if (!response.ok) throw new Error("Error while fetching users");
      if (response) {
        const jsonData = await response.json();
        const reset_date = jsonData.reset_date;
        if (jsonData.image.data) {
          setImg(`data:image/jpeg;base64,${jsonData.image.data}`);
          setImageAvailable(true);
        }
        let b = moment(moment().format("DD-MM-YYYY"), "DD-MM-YYYY");
        let a = moment(reset_date, "DD-MM-YYYY");
        const difference = b.diff(a, "months");
        if (difference >= 1) {
          const data = await resetDate();
          if (data) {
            setUserDetails({ ...jsonData, current_coins: MONTHLY_COINS });
          } else {
            setUserDetails(jsonData);
          }
        } else {
          setUserDetails(jsonData);
        }
        setIsLoading(false);
      }
    } catch (err) {
      console.log("Error while fetching users");
      console.error(err);
    }
  }, [resetDate, userId]);

  const handleNotificationClick = useCallback(async () => {
    try {
      const response: any = await fetch(
        `${process.env.REACT_APP_API_URL}/update-transactions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({
            userId: userId,
          }),
        }
      );
      if (!response.ok) throw new Error("Error while fetching users");
      if (response) {
        setShowModal(true);
      }
    } catch (error) {}
  }, [userId]);

  const fetchUnseenTransactions = useCallback(async () => {
    try {
      const response: any = await fetch(
        `${process.env.REACT_APP_API_URL}/get-transactions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({
            userId: userId,
          }),
        }
      );
      if (response.ok) {
        const allTransactions = await response.json();
        const remTrans = allTransactions.filter(
          (transaction: any) => transaction.has_seen !== true
        );
        setUnseenTransactions(remTrans);
        setTransactionCount(remTrans.length);
      }
    } catch (error) {
      console.log("Error while fetching transactions", error);
    }
  }, [userId]);

  useEffect(() => {
    fetchUserDetails()
      .then(() => {
        console.log("User details fetched");
        fetchUnseenTransactions();
      })
      .catch((err) => {
        console.log("error while fetching the", err);
      });
  }, [fetchUnseenTransactions, fetchUserDetails]);

  const handleEncashSubmit = async () => {
    const { email, total_coins, name } = userDetails;

    try {
      const response: any = await fetch(
        `${process.env.REACT_APP_API_URL}/send-mail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({
            userName: name,
            userEmail: email,
            userMailMessage: `Your Total Coins As of ${moment().format(
              "DD MMM"
            )} is ${total_coins} coins`,
          }),
        }
      );
      if (response.ok) {
        const result = await response.json();
        toast.success("Message Sent Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        console.log(result);
      } else {
        console.log("Error while sending mail!");
        toast.error("Something Went Wrong!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Something Went Wrong!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  if (isLoading || !userDetails) return <LoadingScreen />;

  const ENCASH_THRESHOLD = 25;
  const activeCoins = userDetails.total_coins ?? 0;
  const coinsAwayToEncash = Math.max(0, ENCASH_THRESHOLD - activeCoins);

  const coinsArray = Array.from(
    { length: userDetails.current_coins ?? 0 },
    (_, index) => index + 1
  );

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        theme="light"
      />
      <ModalComponent handleClose={handleClose} open={open} />
      <NotificationModal
        unseenTransactions={unseenTransactions}
        open={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className={styles.myfile}>
        <div className={styles.myfile__tophalf}>
          <div className={styles.myfile__tophalf__nav}>
            <img
              className={styles.myfile__tophalf__nav__left_image}
              src={logoImage}
              alt="Become logo"
            />
            <div className={styles.myfile__tophalf__nav__right_image}>
              <div
                onClick={(e) => handleProflileClick(e)}
                className={styles.myfile__tophalf__nav__right_image}
              >
                <img
                  src={
                    imageAvailable
                      ? img
                      : require("../assets/images/" + userDetails.image)
                  }
                  alt="profile-icon"
                />
              </div>
              <div className={styles.myfile_tophalf_nav_notification}>
                <div
                  style={
                    transactionCount > 0
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  className={styles.myfile_tophalf_nav_transaction_count}
                >
                  {transactionCount}
                </div>
                <div className={styles.myfile_tophalf_nav_transaction_bell}>
                  <GoBell className={styles.bell} onClick={handleOpenModal} />
                </div>
              </div>
            </div>
          </div>

          <div className={styles["leaderboard"]}>
            <LeaderBoardWithCoin
              userDetails={userDetails}
              showLeaderBoard={true}
            />
          </div>

          <div className={styles.myfile__tophalf__main}>
            <div className={styles.myfile__tophalf__main__user}>
              <div className={styles.myfile__tophalf__main__user__img}>
                <img
                  src={
                    imageAvailable
                      ? img
                      : require("../assets/images/" + userDetails.image)
                  }
                  alt="profile-icon"
                />
              </div>
              <button onClick={handleOpen} className={styles["modal-button"]}>
                <h4>{coinsAwayToEncash} coins away to encash &gt;</h4>
              </button>
            </div>
            <div>
              <button
                className={styles.myfile__light_button}
                onClick={handleEncashSubmit}
              >
                Encash
              </button>
            </div>
            <h5>Next Encashment Cycle: Q3 Dec 31st, 2026</h5>
          </div>
        </div>
        <div className={styles.myfile__downhalf}>
          <div className={styles.myfile__downhalf__heading}>
            <div className={styles.myfile__downhalf__heading__date}>
              <h3>{moment().format("DD MMM")}</h3>
            </div>
            <div className={styles.myfile__downhalf__heading__rigthpart}>
              <h2>Available coins</h2>
              <span>{userDetails.current_coins}</span>
            </div>
          </div>
          <div className={styles.overlapping__coins}>
            {coinsArray.map((coin, index) => {
              return (
                <Coins
                  key={index}
                  index={index}
                  size={userDetails.current_coins}
                />
              );
            })}
          </div>
          <button
            type="submit"
            onClick={handleCelebrateClick}
            className={styles.myfile__dark_button}
          >
            Celebrate Becoming
          </button>
          <h4>You can gift 1 coin at a time</h4>
        </div>
      </div>
      <div className={styles["navbar"]}>
        <FooterNavbar userid={userDetails.user_id} />
      </div>
    </>
  );
};

export default Home;
